import React from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../actions/userActions";
import Benefit from "./Benefit";

const HeaderDesktop = ({ backgroundColor }) => {
  const dispatch = useDispatch();

  const userDetails = useSelector((state) => state.userDetails);
  const { user } = userDetails;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const [isLoggedIn, setLoggedIn] = useState(false);
  const logoutHandler = () => {
    dispatch(logout());
    setLoggedIn(false);
  };

  useEffect(() => {
    if (userInfo) {
      setLoggedIn(true);
    } else {
      setLoggedIn(false);
    }
  }, [user, userInfo, isLoggedIn]);

  return (
    <header
      className={`indicador flex items-center h-20 fixed w-full z-20 ${
        backgroundColor ? backgroundColor : "bg-night-blue"
      }`}
    >
      <div className="container flex justify-between items-center w-full gap-3">
        <Link to="/">
          <img
            className="w-52 xl:w-72"
            src={require("../assets/images/logo-vrc-horizontal.png")}
            alt="vrc-logo"
          />
        </Link>
        <div className="flex">
          <ul className="flex items-center text-creamy-beige font-oswald font-semibold uppercase gap-2 2xl:gap-6">
            <li>
              <Link to="/the-platform">The platform</Link>
            </li>
            <li>
              <Link to="/our-network">Our Network</Link>
            </li>
            <li>
              <Link to="/for-teachers">for teachers</Link>
            </li>
            <li>
              <Link to="/for-partners">for partners</Link>
            </li>
            <li>
              <Link to="/contact">contact</Link>
            </li>
            {isLoggedIn && userInfo && (
              <li>
                <Link to="/catalogue">listings catalogue</Link>
              </li>
            )}
          </ul>

          <div className="auth-menu ml-2">
            {isLoggedIn && userInfo && (
              <Link to="/messages">
                <i
                  className="iconify text-creamy-beige"
                  data-icon="subway:sms-3"
                />
              </Link>
            )}
            {isLoggedIn && userInfo ? (
              <div className="btn header-dashboard-btn">
                {userInfo && userInfo.name?.split(" ")[0]}
                {userInfo && isLoggedIn && (
                  <>
                    <Benefit
                      visual={
                        userInfo.type === "admin"
                          ? "/images/avatar-admin.png"
                          : userInfo.avatar
                      }
                    />
                    <ul>
                      <li>
                        <Link
                          to={userInfo.type === "admin" ? "/admin" : "/account"}
                        >
                          dashboard
                        </Link>
                      </li>
                      {userInfo.type !== "admin" && (
                        <li>
                          <Link to={`/mybookings`}>my bookings</Link>
                        </li>
                      )}
                      {userInfo.type !== "admin" && (
                        <li>
                          <Link to={`/${userInfo.type}/${userInfo._id}`}>
                            my profile
                          </Link>
                        </li>
                      )}
                      <li onClick={logoutHandler}>logout</li>
                    </ul>
                  </>
                )}
              </div>
            ) : (
              <Link
                to="/login"
                className="bg-canton-jadesheen hover:bg-yellow text-night-blue font-oswald font-semibold ml-6 pb-2 py-3 px-9 uppercase"
              >
                login
              </Link>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderDesktop;
